module.exports = __webpack_public_path__ + "static/media/ultralight-alternatives.17a5e943.jpg";